import React from 'react';
import styled from 'styled-components';

import { iCell } from '../models/GameModels';

const CellWrapper = styled.button`
  width: 5rem;
  height: 5rem;
  font-size: 3rem;
  border: 1px solid #00CCB4;
  background: #fff;
  cursor: pointer;
  &:hover {
    background: #00ccb41f;
  }
  &:disabled {
    pointer-events: none;
  }
`;

type CellProps = {
  cellValue: iCell,
  coordinates: { x: number, y: number },
  clickFunction: (x: number, y: number) => void,
  gameOver: boolean,
};

const getCellValue = (cellValue: iCell) => {
  switch (cellValue) {
    case iCell.X: return '❌';
    case iCell.O: return '⭕';
    default: return '';
  }
}

export default function Cell(props: CellProps) {
  const { cellValue, clickFunction, coordinates, gameOver } = props;
  return (
    <CellWrapper
      disabled={gameOver}
      onClick={() => clickFunction(coordinates.x, coordinates.y)}>
      {getCellValue(cellValue)}
    </CellWrapper>
  )
}